import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiDefinition = z.object({
  kpiDefinitionId: z.string(),
  kpiName: z.string(),
  kpiDescription: z.string()
})

const ZTiqKpiDefinitionDTO = z.object({
  totalCount: z.number(),
  content: z.array(ZKpiDefinition)
})

export type TiqKpiDefinitionDTO = z.infer<typeof ZTiqKpiDefinitionDTO>

export type KpiDefinitionData = z.infer<typeof ZKpiDefinition>

export async function deleteCustomKpiByKpiDefinitionId (
  kpiDefinitionId: string,
  onSuccess: (httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/kpi/deleteCustomKpi/${kpiDefinitionId}`
  interceptedAxios
    .delete(url, {
      timeout: 25000
    })
    .then((response: any) => {
      onSuccess(response.status)
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
